import { add as hasAdd } from '@dojo/framework/core/has';

hasAdd('dev-build', !/partnerrc|hclspstaging/.test(window.location.hostname));
hasAdd('quiz-progress-chart', true);
hasAdd('use-landing-page', true);

hasAdd('use-alternate-next', true);
hasAdd('use-alternate-pass-view', true);
hasAdd('use-assessment-chooser', true);
hasAdd('use-audio-topics', true);
hasAdd('use-carousel-view', true);
hasAdd('use-cutscores', false);
// hasAdd('use-ml-study-plan', true);
hasAdd('use-search-in-heading', true);
hasAdd('use-study-plan', true);
hasAdd('use-xapi', true);
hasAdd('use-topicgroup-reading', true);
hasAdd('use-topicgroup-quiz', false);
hasAdd('practice-exam', true);
hasAdd('posttest', true);

